import { render, staticRenderFns } from "./PartnerCampaignView.vue?vue&type=template&id=72279e00&scoped=true"
import script from "./PartnerCampaignView.vue?vue&type=script&lang=js"
export * from "./PartnerCampaignView.vue?vue&type=script&lang=js"
import style0 from "./PartnerCampaignView.vue?vue&type=style&index=0&id=72279e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72279e00",
  null
  
)

export default component.exports